<div class="flex h-full flex-col">
  <header class="flex flex-none items-center justify-between border-b border-gray-200 px-6 py-4">
    <h1 class="text-base font-semibold leading-6 text-gray-900">
      <time [dateTime]="selected().format('YYYY-MM')">
        {{ 'datePicker.month.' + selected().month() | translate }} {{ selected().year() }}
      </time>
    </h1>
    <div class="flex items-center">

      <div class="relative flex items-center rounded-md bg-white shadow-sm md:items-stretch">
        <select (change)="changeCategory($event)" [disabled]="loading()" autocomplete="category"
                class="appearance-none mr-4 h-9 text-gray-700 border border-gray-200 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                id="category"
                name="category">
          <option value="0">{{ 'all' | translate }}</option>
          @for (category of categories(); track category.label; ) {
            <option [value]="category.erpId">{{ category.label }}</option>
          }
        </select>
        <button (click)="previousWeek()"
                (keyup.enter)="emulateClick($event)"
                class="flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l border-gray-300 pr-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-gray-50"
                type="button">
          <span class="sr-only">Previous week</span>
          <svg aria-hidden="true" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <path clip-rule="evenodd"
                  d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                  fill-rule="evenodd"/>
          </svg>
        </button>
        <button (click)="selected.set(today())"
                (keyup.enter)="emulateClick($event)"
                class="hidden border-y border-gray-300 px-3.5 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:relative md:block"
                type="button">
          {{ 'today' | translate }}
        </button>
        <span class="relative -mx-px h-5 w-px bg-gray-300 md:hidden"></span>
        <button (click)="nextWeek()"
                (keyup.enter)="emulateClick($event)"
                class="flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r border-gray-300 pl-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-gray-50"
                type="button">
          <span class="sr-only">Next week</span>
          <svg aria-hidden="true" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <path clip-rule="evenodd"
                  d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                  fill-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </div>
  </header>
  @if (loading()) {
    <div class="w-full overflow-hidden h-2">
      <div class='progress w-full h-full bg-bleuCaliceo-300 left-right'></div>
    </div>
  }
  <div class="isolate flex flex-auto flex-col overflow-auto bg-white">
    <div class="flex max-w-full flex-none flex-col md:max-w-full" style="width: 165%">
      <div class="sticky top-0 z-30 flex-none bg-white shadow ring-1 ring-black ring-opacity-5 md:pr-8">
        <div class="grid grid-cols-7 text-sm leading-6 text-gray-500 md:hidden">
          @for (day of planning(); track day.unix()) {
            <button type="button"
                    (click)="selected.set(day)"
                    class="flex flex-col items-center pb-3 pt-2">{{ 'datePicker.week.' + day.day() | translate }}
              <span class="mt-1 flex h-8 w-8 items-center justify-center font-semibold"
                    [ngClass]="selected().isSame(day, 'day') ? 'text-bleuCaliceo-300 font-bold' : 'text-gray-900'">
                {{ day.date() }}
              </span>
            </button>
          }
        </div>

        <div
          class="-mr-px hidden grid-cols-7 divide-x divide-gray-100 border-r border-gray-100 text-sm leading-6 text-gray-500 md:grid">
          <div class="col-end-1 w-14"></div>

          @for (day of planning(); track day.unix()) {
            <div class="flex items-center justify-center py-3">
              <span>{{ 'datePicker.week.long.' + day.day() | translate }} <span
                class="items-center justify-center font-semibold text-gray-900">{{ day.date() }}</span></span>
            </div>
          }
        </div>
      </div>
      <div class="flex flex-auto">
        <div class="sticky left-0 z-10 w-14 flex-none bg-white ring-1 ring-gray-100"></div>
        <div class="grid flex-auto grid-cols-1 grid-rows-1">
          <!-- Horizontal lines -->
          <div class="col-start-1 col-end-2 row-start-1 grid divide-y divide-gray-100"
               style="grid-template-rows: repeat(50, minmax(3.5rem, 1fr))">
            @for (timeSlot of timeSlots(); track timeSlot) {
              <div>
                <div class="sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400">
                  {{ timeSlot }}
                </div>
              </div>
            }
          </div>
          <!-- Vertical lines -->
          <div
            class="col-start-1 col-end-2 row-start-1 hidden grid-cols-7 grid-rows-1 divide-x divide-gray-100 md:grid md:grid-cols-7">
            <div class="col-start-1 row-span-full"></div>
            <div class="col-start-2 row-span-full"></div>
            <div class="col-start-3 row-span-full"></div>
            <div class="col-start-4 row-span-full"></div>
            <div class="col-start-5 row-span-full"></div>
            <div class="col-start-6 row-span-full"></div>
            <div class="col-start-7 row-span-full"></div>
            <div class="col-start-8 row-span-full w-8"></div>
          </div>

          <!-- Events -->
          <ol class="col-start-1 col-end-2 row-start-1 grid grid-cols-1 md:grid-cols-7 md:pr-8"
              style="grid-template-rows: repeat(200, minmax(0, 1fr)) auto">
            @for (event of eventsComputed(); track event) {
              <li class="relative" [style]="event.styles"
                  [ngClass]="{
                  'hidden md:flex': !event.ofDaySelected,
                  'flex': event.ofDaySelected,
                  'md:col-start-1': event.day === 1,
                  'md:col-start-2': event.day === 2,
                  'md:col-start-3': event.day === 3,
                  'md:col-start-4': event.day === 4,
                  'md:col-start-5': event.day === 5,
                  'md:col-start-6': event.day === 6,
                  'md:col-start-7': event.day === 7,
                  }">
                <div
                  role="button"
                  (click)="!event.past && eventClicked.emit(event)"
                  (keyup.enter)="emulateClick($event)"
                  tabindex="0"
                  class="group absolute inset-1 flex gap-4 overflow-y-auto rounded-lg p-2 text-xs leading-5"
                  [style.background-color]="event['course']['color']+'AA'"
                  [ngClass]="{
                  '!bg-green-50 hover:!bg-green-100': event['participating'] === 'yes',
                  '!bg-yellow-50 hover:!bg-yellow-100': event['participating'] === 'waiting',
                  '!bg-gray-100 hover:!bg-gray-100': event.past,
                  'hover:!bg-bleuCaliceo-300': !event.past
                  }">
                  <div class="hidden relative basis-1/5">
                    <img class="object-contain" fill="" [ngSrc]="'assets/icons/blue/' + event['course']['icon']" alt="">
                  </div>
                  <div class="grow flex flex-col">
                    <time class="text-sm" [dateTime]="event.date+'T'+event.start">{{ event.start }}
                      - {{ event['end'] }}
                    </time>
                    <p class="font-bold">{{ event['course']['label'] }}</p>
                    <p class="font-bold uppercase">
                      @if (event['participating'] === 'yes') {
                        {{ 'participating' | translate }}
                      } @else if (event['participating'] === 'waiting') {
                        {{ 'waiting' | translate }}
                      } @else if (!event['remainingCapacity'] && !event['remainingWaitingCapacity']) {
                        {{ 'full' | translate }}
                      } @else if (event['remainingCapacity']) {
                        {{ 'remainingCapacity' | translate:{ remaining: event['remainingCapacity'] } }}
                      } @else {
                        {{ 'remainingWaitingCapacity' | translate:{ remaining: event['remainingWaitingCapacity'] } }}
                      }
                    </p>
                  </div>
                </div>
              </li>
            }
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>
